import React, { useState, useContext, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";

import BizinBackend from "../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import { DF_LO0012Context } from "../context";

import CardFlow from "../../../components/Common/CardFlow";
import CardContext from "../../../components/Common/CardContext";
import useGetHeightPage from "../../../Hooks/useGetHeightPage";

function GridBody() {
  const { parseParams } = useContext(DF_LO0012Context);
  const ID_Arquivo = parseParams.get("ID_Arquivo");

  const csrfToken = useGetCsrfToken();
  useGetHeightPage();

  const { userProfile, access_token, isModalPage } = useSelector((state) => ({
    userProfile: state.login.profile,
    access_token: state.login.user.access_token,
    isModalPage: state.Layout.isModalPage,
  }));

  const [flowData, setFlowData] = useState([]);
  const [contextData, setContextData] = useState([]);

  const [motivo, setMotivo] = useState("");
  const [observacao, setObservacao] = useState("");

  const [reasons, setReasons] = useState([]);
  const [openReasons, setOpenReasons] = useState(false);

  const [loading, setLoading] = useState(false);
  const [screenMode, setScreenMode] = useState("form");
  const [errorMessage, setErrorMessage] = useState("");

  const handleCloseModal = () => {
    if (window.top !== window.self) {
      window.parent.postMessage(
        { type: "closeModal", isReloadPage: true },
        "*",
      );
    } else {
      window.close();
    }
  };

  useEffect(() => {
    if (!ID_Arquivo) return;

    const loadData = async () => {
      try {
        const [flowResp, cteResp, reasonsResp] = await Promise.all([
          BizinBackend.executeProcedure(
            {
              1: userProfile?.ID_Usuario,
              2: "pt-BR",
              3: ID_Arquivo,
            },
            "FRONT_Workspace_Obter_Documento_Fluxo_Participantes",
            csrfToken,
            access_token,
          ),
          BizinBackend.executeProcedure(
            {
              1: userProfile?.ID_Usuario,
              2: 'pt-BR',
              3: ID_Arquivo,
              4: 'CT',
            },
            "FRONT_Workspace_DF_LO0012_Documento_Transporte_Obter_Cabecalho",
            csrfToken,
            access_token,
          ),
          BizinBackend.executeProcedure(
            {},
            "EDI_Get_Motivos_Anulacao",
            csrfToken,
            access_token,
          ),
        ]);

        const flowResult = Array.isArray(flowResp) ? flowResp : [];

        setFlowData(
          flowResult.map((item) => ({
            name: item.Nome_Empresa,
            description: item.Descricao,
            logo: item.Logo_Empresa,
          })),
        );

        const cteResult = Array.isArray(cteResp) ? cteResp : [];

        if (cteResult.length > 0) {
          cteResult.map((item) => {
            item.label = item.Coluna;
            item.value = item.Valor;
          })

          setContextData(cteResult);
        }

        const reasonsResult = Array.isArray(reasonsResp) ? reasonsResp : [];

        setReasons(
          reasonsResult.map((item) => ({
            label: item.Descricao,
            value: item.Descricao,
          })),
        );
      } catch (error) {
        console.log("erro ao carregar dados", error);
      }
    };

    loadData();
  }, [
    ID_Arquivo,
    csrfToken,
    access_token,
    userProfile?.ID_Usuario,
    userProfile?.ID_Idioma,
  ]);

  const removerValidacao = async () => {
    try {
      setLoading(true);

      await BizinBackend.executeProcedure(
        {
          1: userProfile.ID_Usuario,
          2: ID_Arquivo,
          3: motivo,
          4: observacao,
        },
        "FRONT_NotaFiscal_Remover_Validacao_Documento",
        csrfToken,
        access_token,
      );

      setScreenMode("success");
    } catch (error) {
      console.log(error);

      setErrorMessage("Erro ao remover validação");
      setScreenMode("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {screenMode === "form" && (
        <>
          <Row className="my-3 d-flex align-items-center">
            <Col md={isModalPage ? 12 : 'auto'}>
              {flowData.length > 0 && (
                <div className="mb-3">
                  <CardFlow flowData={flowData} enableTooltip={false} />
                </div>
              )}
            </Col>

            <Col md={isModalPage ? 12 : ''}>
              {contextData.length > 0 && (
                <div className="mb-3">
                  <CardContext data={contextData} enableTooltip={false} />
                </div>
              )}
            </Col>

            <Col xs={12} className="mb-3">
              <label className="fw-semibold fs-6 text-color-azul1 mb-2">
                Motivo da Remoção da Validação
              </label>

              <div className="position-relative">
                <div
                  className="form-control d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setOpenReasons(!openReasons)}
                >
                  <span>{motivo || "Selecionar"}</span>

                  <i
                    className={`fas ${
                      openReasons ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </div>

                {openReasons && (
                  <div
                    className="shadow mt-1"
                    style={{
                      position: "absolute",
                      left: 0,
                      width: "100%",
                      zIndex: 999,
                      maxHeight: "250px",
                      overflowY: "auto",
                      borderRadius: "6px",
                      boxSizing: "border-box",
                      backgroundColor: "#F5F5F5",
                    }}
                  >
                    {reasons.map((item, index) => (
                      <div
                        key={index}
                        className={`reason-item ${
                          motivo === item.value ? "active" : ""
                        }`}
                        onClick={() => {
                          setMotivo(item.value);
                          setOpenReasons(false);
                        }}
                      >
                        <span>{item.label}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Col>

            <Col xs={12} className="mb-3">
              <label className="fw-semibold fs-6 text-color-azul1 mb-2">
                Observações
              </label>

              <textarea
                className="form-control"
                rows={4}
                placeholder="Digite aqui a observação (opcional)"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              className="btn fw-semibold btn-cancelar-co0005"
              onClick={() => setScreenMode("confirmCancel")}
            >
              Cancelar
            </button>

            <button
              className="btn fw-semibold btn-confirmar-co0005"
              onClick={() => {
                if (!motivo) {
                  setErrorMessage(
                    "Selecione o motivo da remoção da validação",
                  );

                  setScreenMode("error");
                  return;
                }

                setScreenMode("confirmRemove");
              }}
              disabled={loading}
            >
              {loading ? "Processando..." : "Remover validação"}
            </button>
          </div>
        </>
      )}

      {screenMode === "confirmRemove" && (
        <div>
          <div className="text-center">
            <div className="icon-warning mb-4">
              <i className="fas fa-exclamation-triangle"></i>
            </div>

            <h5 className="modal-title-custom mb-4">
              Realmente deseja remover a validação
              <br />
              deste Documento de Transporte?
            </h5>

            <div className="modal-actions">
              <button
                className="btn border-0 fw-bold px-4 btn-cancelar-co0005"
                onClick={() => setScreenMode("form")}
              >
                Cancelar
              </button>

              <button
                className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
                onClick={removerValidacao}
                disabled={loading}
              >
                {loading ? "Processando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}

      {screenMode === "confirmCancel" && (
        <div>
          <div className="text-center">
            <div className="icon-warning mb-4">
              <i className="fas fa-exclamation-triangle"></i>
            </div>

            <h5 className="modal-title-custom mb-3">
              Realmente deseja
              <br />
              cancelar a operação?
            </h5>

            <p className="modal-description mb-4">
              Você perderá o progresso feito até agora.
            </p>

            <div className="modal-actions">
              <button
                className="btn border-0 fw-semibold px-4 btn-cancelar-co0005"
                onClick={() => setScreenMode("form")}
              >
                Voltar
              </button>

              <button
                className="btn border-0 fw-semibold px-4 btn-confirmar-co0005"
                onClick={() => {
                  setScreenMode("successCancel");
                }}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {screenMode === "success" && (
        <div>
          <div className="text-center">
            <div className="icon-success mb-4">
              <i className="fas fa-check"></i>
            </div>

            <h5 className="modal-title-custom mb-3">Sucesso!</h5>

            <p className="modal-subtext mb-4">
              Operação realizada com sucesso!
            </p>

            <button
              className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
              onClick={handleCloseModal}
            >
              Ok!
            </button>
          </div>
        </div>
      )}

      {screenMode === "successCancel" && (
        <div>
          <div className="text-center">
            <div className="icon-success mb-4">
              <i className="fas fa-check"></i>
            </div>

            <h5 className="modal-title-custom mb-3">Operação cancelada</h5>

            <p className="modal-subtext mb-4">
              A remoção da validação foi cancelada.
            </p>

            <button
              className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
              onClick={() => setScreenMode("form")}
            >
              Ok!
            </button>
          </div>
        </div>
      )}

      {screenMode === "error" && (
        <div>
          <div className="text-center">
            <div className="icon-error mb-4">
              <i className="fas fa-times"></i>
            </div>

            <h5 className="modal-title-custom mb-3">
              Não foi possível completar a operação
            </h5>

            <p className="modal-subtext mb-4">{errorMessage}</p>

            <button
              className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
              onClick={() => setScreenMode("form")}
            >
              Ok!
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default GridBody;
